export type Testimonial = {
  quote: string
  name: string
  location: string
  detail?: string
}

export const testimonialsBlockOne: Testimonial[] = [
  {
    quote:
      'Llevaba dos años comiendo lo mismo todos los días porque no sabía qué más podía comer sin miedo. Con el MegaPack armé el menú de toda la semana en una tarde. Por primera vez en mucho tiempo me senté a comer sin angustia.',
    name: 'Marta G.',
    location: 'Córdoba',
    detail: 'Diabetes tipo 2',
  },
  {
    quote:
      'Mi marido tiene diabetes y se negaba a comer “comida de enfermo”. Con las recetas del Tomo 3 hicimos el asado del domingo igual que siempre. Él no lo podía creer. Yo tampoco.',
    name: 'Claudia R.',
    location: 'Rosario',
  },
  {
    quote:
      'El Tomo 6 de planificación me cambió la semana entera. Ya no improviso. Ya no me pregunto qué cocinar. Mi glucosa nunca estuvo tan estable desde el diagnóstico.',
    name: 'Jorge M.',
    location: 'Buenos Aires',
    detail: 'Diabetes tipo 2',
  },
  {
    quote:
      'Lo compré para mi mamá y terminamos usándolo toda la familia. La comida mejoró para todos. Ella bajó 4 puntos de glucosa en dos meses.',
    name: 'Diego F.',
    location: 'Buenos Aires',
  },
]

export const testimonialsBlockTwo: Testimonial[] = [
  {
    quote:
      'Mi nutricionista me dijo que era imposible seguir comiendo asado. Con el MegaPack le mostré cómo lo adaptamos en casa. Ahora ella les recomienda el sistema a sus pacientes.',
    name: 'Roberto S.',
    location: 'La Plata',
    detail: 'Diabetes tipo 2',
  },
  {
    quote:
      'Los primeros tres meses después del diagnóstico comí pechuga a la plancha todos los días. Ahora tengo 6 tomos llenos de recetas que me gustan de verdad. No cambio el MegaPack por nada.',
    name: 'Silvia P.',
    location: 'Tucumán',
  },
  {
    quote:
      'La Guía de Sustituciones Criollas vale sola lo que cuesta el MegaPack. Finalmente entendí cómo reemplazar los ingredientes sin que la comida pierda el sabor que me gusta.',
    name: 'Patricia V.',
    location: 'Mendoza',
  },
  {
    quote:
      'Con el Tomo 5 de snacks dejé de picar mal a las 4 de la tarde. Parece un detalle. Mi glucosa de las 6 de la tarde dice que no es un detalle.',
    name: 'Marcelo T.',
    location: 'Neuquén',
  },
]
